import React from 'react';
import DevelopmentInProgress from '../../../../components/common/DevelopmentInProgress';

export default function PaymentsMadeGeneral({ setError, error, setForm, form }) {
	return <DevelopmentInProgress />;
}
